import { loadListByShortcut } from 'isotope-client/modules/valueList/services/valueListActions'

export const loadListFoByShortcut = (shortcut, idLanguage) => dispatch => loadListByShortcut(shortcut, idLanguage, false)(dispatch)
